{
  "page": {
    "intro": "Where the shop sends to, how much it costs, the delivery companies and import duties. Customers see exactly what is set here.",
    "read_only": "You can read these settings. Only the owner can change them."
  },
  "tabs": {
    "label": "Shipping settings",
    "zones": "Where we send",
    "carriers": "Delivery companies",
    "duties": "Import duties",
    "packaging": "Packing",
    "calculator": "Try it"
  },
  "lang": {
    "en": "English",
    "ja": "Japanese",
    "th": "Thai",
    "zh-Hant": "Chinese (Traditional)",
    "zh-Hans": "Chinese (Simplified)",
    "en_hint": "Used in every language that is left empty."
  },
  "zones": {
    "intro": "A zone is a group of places with the same ways to ship. Each country (or Japanese prefecture) can be in one zone only.",
    "add": "Add a zone",
    "start_from": "Start from",
    "start_empty": "Empty zone (choose the countries yourself)",
    "rest_of_world": "Rest of the world (every country not in a zone yet)",
    "countries_count_one": "{{count}} country",
    "countries_count_other": "{{count}} countries",
    "more_one": "+{{count}} more",
    "more_other": "+{{count}} more",
    "empty_title": "No zones yet",
    "empty_body": "Add a zone for Japan first, then one for each group of countries you send to.",
    "load_failed": "The shipping zones could not be loaded",
    "on": "Customers can choose it",
    "off": "Switched off",
    "edit": "Change places",
    "view": "See places",
    "rates_of": "Ways to ship to {{zone}}",
    "no_rates": "No way to ship yet — customers in this zone cannot order until you add one.",
    "upcoming": "Price changes that start later",
    "past_one": "{{count}} older price (kept for orders already placed)",
    "past_other": "{{count}} older prices (kept for orders already placed)",
    "carriers_all": "Delivery companies: all",
    "carriers_some": "Delivery companies: {{names}}"
  },
  "zone": {
    "new": "New zone",
    "new_from": "New zone: {{name}}",
    "description": "The countries in this zone, and for Japan all of it or only some prefectures.",
    "name": "Name of the zone",
    "name_required": "Type the English name (it is used when a language is empty).",
    "countries_one": "Countries in this zone ({{count}})",
    "countries_other": "Countries in this zone ({{count}})",
    "chosen": "Chosen countries",
    "no_countries": "No country chosen yet.",
    "remove_country": "Remove {{name}}",
    "search_country": "Find a country",
    "countries_required": "Choose at least one country.",
    "japan_part": "Which part of Japan",
    "japan_all": "All of Japan",
    "japan_some": "Only some prefectures (priced apart, e.g. Okinawa)",
    "prefectures": "Prefectures",
    "regions_required": "Tick at least one prefecture, or choose \"All of Japan\".",
    "left_out": "Already in another zone, so left out: {{places}}",
    "active": "Customers can choose this zone",
    "active_hint": "Switch off to stop offering it without deleting anything.",
    "note": "Note for the shop (customers do not see it)",
    "save": "Save zone",
    "created": "Zone added",
    "saved": "Zone saved",
    "delete": "Delete zone",
    "delete_title": "Delete the zone {{name}}?",
    "delete_body": "Customers in these places can no longer order. Orders already placed keep their shipping price.",
    "cannot_delete_title": "{{name}} still has ways to ship",
    "cannot_delete_body_one": "It has {{count}} way to ship, so it cannot be deleted. Switch it off instead: customers stop seeing it, orders already placed keep their shipping price.",
    "cannot_delete_body_other": "It has {{count}} ways to ship, so it cannot be deleted. Switch it off instead: customers stop seeing it, orders already placed keep their shipping price.",
    "switch_off": "Switch the zone off",
    "switched_off": "Zone switched off",
    "deleted": "Zone deleted",
    "carriers": "Delivery companies for this zone",
    "carriers_all": "All companies",
    "carriers_some": "Only the ticked companies",
    "carriers_hint": "Ways to ship with a company that is not ticked stay saved, but customers of this zone do not see them.",
    "carriers_required": "Tick at least one delivery company, or choose \"All companies\"."
  },
  "rate": {
    "add": "Add a way to ship",
    "new_in": "New way to ship — {{zone}}",
    "description": "Your own prices, including tax. Customers see the cheapest first.",
    "edit": "Change",
    "view": "See",
    "save": "Save",
    "created": "Way to ship added",
    "saved": "Way to ship saved",
    "off": "(switched off)",
    "name": "Name customers see",
    "carrier": "Delivery company",
    "how_priced": "How is the price set?",
    "type": {
      "flat": "One price",
      "weight": "By weight",
      "price": "By order total",
      "free_over": "Free from an amount",
      "pickup": "Pick up at the shop"
    },
    "type_hint": {
      "flat": "Same price for every parcel (e.g. Click Post).",
      "weight": "A price for each weight step (e.g. Yu-Pack).",
      "price": "A price for each order total step.",
      "free_over": "A price, free when the order reaches an amount."
    },
    "price": "Price",
    "free_from": "Free from order total",
    "free_from_hint": "Order total after discounts.",
    "tiers_weight": "Price by weight",
    "tiers_weight_hint": "Lightest first. A parcel uses the first step it fits in; heavier than the last step = not offered.",
    "tiers_price": "Price by order total",
    "tiers_price_hint": "Smallest total first. Leave \"up to\" empty on the last row for \"and above\".",
    "tier_up_to_g": "Row {{row}}: up to (grams)",
    "tier_up_to_yen": "Row {{row}}: order total up to",
    "tier_last_hint": "Empty = and above",
    "tier_price": "Row {{row}}: price",
    "tier_remove": "Remove row {{row}}",
    "tier_add": "Add a row",
    "max_weight": "Heaviest parcel",
    "max_weight_hint": "Empty = no limit of its own.",
    "eta_min": "Arrives in (fastest)",
    "eta_max": "Arrives in (slowest)",
    "days": "days",
    "eta_days": "{{min}}–{{max}} days",
    "protection": "Tracking and insurance",
    "tracked": "Has a tracking number",
    "insured": "Insured (the company pays if lost or damaged)",
    "insured_rule": "Orders of {{amount}} or more are offered only insured ways.",
    "coverage": "Insured up to",
    "coverage_hint": "Empty = the full value.",
    "can_add_insurance": "Extra insurance can be bought",
    "signature": "Signature on delivery",
    "more": "More choices",
    "service_level": "Kind of service",
    "service_level_none": "Not set",
    "service_tier": {
      "economy_tracked": "Cheap, with tracking",
      "standard_insured": "Standard, insured",
      "express_courier": "Express courier"
    },
    "duties_default": "Import duty (default for this way)",
    "duties_default_hint": "Parcels to the US of $100–2,500 by post are always prepaid (the system does it).",
    "min_subtotal": "Only for order totals from",
    "max_subtotal": "Only for order totals up to",
    "max_declared": "Highest value it may carry",
    "starts_on": "Price starts on",
    "starts_on_hint": "Empty = today. A later day keeps today's price until then.",
    "active": "Customers can choose it",
    "active_hint": "Switch off to stop offering it without deleting it.",
    "notes": "Note for the shop",
    "notes_hint": "E.g. where the price comes from. Customers do not see it.",
    "starts": "Starts {{date}}",
    "badge": {
      "insured": "Insured",
      "signature": "Signature",
      "untracked": "No tracking",
      "unverified": "Price not checked yet",
      "max_thickness": "up to {{mm}} mm thick",
      "carrier_off": "Company switched off for this zone — customers do not see it"
    },
    "summary": {
      "up_to": "up to {{limit}} {{price}}",
      "above": "above: {{price}}",
      "free_over": "{{price}}, free from {{from}}"
    },
    "delete": "Delete",
    "delete_named": "Delete {{name}}",
    "delete_title": "Delete {{name}}?",
    "delete_consequence": "Customers can no longer choose it. Orders already placed keep their shipping price.",
    "deleted": "Way to ship deleted",
    "problem": {
      "fix_marked": "Please fix the marked boxes.",
      "name_en": "Type the English name (it is used when a language is empty).",
      "carrier": "Choose the delivery company.",
      "price": "Type the price in whole yen.",
      "tiers_empty": "Add at least one row with a price.",
      "tiers_weight": "Every row needs a weight in grams and a price in whole yen.",
      "tiers_price": "Every row needs a price; only the last row may leave \"up to\" empty.",
      "free_over": "Type the order total from which shipping is free.",
      "numbers": "Weights and amounts must be whole numbers.",
      "eta": "Days must be whole numbers, the fastest not more than the slowest."
    },
    "max_thickness": "Thickest parcel",
    "max_thickness_hint": "Mailbox services: 30 mm (3 cm). Empty = no limit."
  },
  "grid": {
    "open": "Quick prices by weight",
    "title": "Prices by weight — {{zone}}",
    "description": "Type your prices. An empty box means no price step at that weight.",
    "way": "Way to ship",
    "up_to": "up to {{weight}}",
    "cell": "{{name}}, up to {{weight}}",
    "hint": "A parcel uses the first step it fits in. Heavier steps may not be cheaper.",
    "add_weight": "Add a weight step (grams)",
    "add_weight_button": "Add step",
    "weight_invalid": "Type a weight from 1 to 30,000 grams.",
    "whole_yen": "Prices must be whole yen.",
    "download": "Download for a spreadsheet",
    "upload": "Read a spreadsheet file",
    "csv_unreadable": "This file has no \"code\" column or no weight columns. Download the table first and fill that file.",
    "csv_unknown": "Not in this table, left out: {{codes}}",
    "save": "Save prices",
    "saved_one": "{{count}} way to ship saved",
    "saved_other": "{{count}} ways to ship saved",
    "some_failed_one": "{{count}} row was not saved — see the red text.",
    "some_failed_other": "{{count}} rows were not saved — see the red text."
  },
  "carrier": {
    "intro": "The tracking link in customer e-mails opens the page set here. It must be the company's own website.",
    "load_failed": "The delivery companies could not be loaded",
    "domestic": "In Japan",
    "international": "Abroad",
    "insurable": "Can be insured",
    "customs": "Needs a customs form",
    "changed_by_shop": "Changed by the shop",
    "on": "In use",
    "off": "Not used",
    "use": "Use this company",
    "warning_ignored": "A change of the shop could not be used (wrong website), so the standard page is used.",
    "page": "Tracking page",
    "page_hint": "https on the company's website, with {n} where the number goes.",
    "sample": "Number to test with",
    "sample_hint": "Example: {{example}}",
    "test": "Open the tracking page of {{name}}",
    "test_unavailable": "This page cannot be used: https on the company's website with {n} once.",
    "save_page": "Save tracking page",
    "back_to_default": "Back to the standard page",
    "saved": "{{name}} saved",
    "template_refused": "This page was refused: it must be https on the company's own website, with {n} once."
  },
  "duties": {
    "intro": "Who pays the import duty of each market, and the rate the checkout uses for its estimate. The rate changes often — change it here, it is used at once.",
    "source": "Research: US duty on cards from Japan about 12.5% since 2026-07-24 (checked 2026-09-24, not confirmed as law text) — {{file}}. Check again with Zonos / the customs before sending.",
    "no_access": "Import duties are with the tax settings",
    "no_access_body": "Ask the owner or a manager to open this page.",
    "load_failed": "The markets could not be loaded",
    "every_other_country": "Every other country",
    "updated": "Last changed",
    "us_rule": "US by post, $100–2,500: the duty must be prepaid (DDP, through Zonos). The system applies this by itself.",
    "who_pays": "Who pays the import duty",
    "mode": {
      "DDU": "Customer pays on arrival (DDU)",
      "DDP": "Shop prepays (DDP)"
    },
    "mode_hint": {
      "DDU": "The customer may be asked for duty and a fee by the carrier.",
      "DDP": "The checkout shows an estimate; the shop pays it before sending."
    },
    "percent": "Duty rate",
    "percent_hint": "Empty = no estimate. Up to 3 decimals, e.g. 12.5.",
    "percent_invalid": "Type a rate from 0 to 100, e.g. 12.5.",
    "notice": "Sentence customers read at checkout",
    "notice_hint": "Empty = the shop's standard sentence for this choice.",
    "save": "Save duties",
    "saved": "Duties of {{name}} saved",
    "confirm_title": "Change the duties of {{name}}?",
    "confirm_body": "New checkouts show this right away.",
    "confirm_percent": "Rate: {{percent}}%",
    "confirm_no_percent": "No rate (no estimate)"
  },
  "packaging": {
    "intro": "What the system adds to every parcel to work out its weight and thickness — the same numbers as the checkout. A change is used by the next customer at once.",
    "load_failed": "The packing weights could not be loaded",
    "box": "Packing of each parcel",
    "box_hint": "Box, bubble wrap and filler.",
    "pack": {
      "raw_single": "One card with sleeve, toploader and team bag — when the card has no weight of its own.",
      "graded_single": "One graded card with slab sleeve, hard box and bubble wrap.",
      "sealed_product": "One sealed box or pack — when it has no weight of its own.",
      "supplies": "One accessory — when it has no weight of its own."
    },
    "insured_from": "Insured ways only from",
    "insured_from_hint": "Orders of this value or more are offered only insured ways (signature and photos of the parcel recommended).",
    "read_only": "Only people who may change the shop settings can change these numbers.",
    "weight": "Weight of the packing",
    "thickness": "Thickness of the packing",
    "weight_one": "Weight of one",
    "thickness_one": "Thickness of one (packed)",
    "start_value": "Starting value: {{value}}.",
    "thickness_note": "Thickness decides the 3 cm mailbox services (Click Post, Yu-Packet, Letter Pack Light). The starting values are rough — measure a packed parcel and type your own.",
    "save": "Save",
    "saved": "Saved — the next customer sees the new shipping prices",
    "reset": "Back to the starting values",
    "conflict": "Someone else saved these numbers just now. Boxes you did not touch now show their numbers. The numbers you typed are kept but NOT saved yet — under each of them you see what is saved now. Press Save to use yours, or take the saved numbers.",
    "problem": {
      "number": "Type a whole number in the allowed range.",
      "summary_one": "{{count}} box needs a whole number in the allowed range — see the red text.",
      "summary_other": "{{count}} boxes need a whole number in the allowed range — see the red text."
    },
    "saved_now": "Saved now: {{value}}.",
    "take_saved": "Use the saved numbers"
  },
  "product_type": {
    "raw_single": "Card (not graded)",
    "graded_single": "Graded card",
    "sealed_product": "Sealed box / pack",
    "supplies": "Accessory"
  },
  "calc": {
    "form": "What to try",
    "intro": "Choose where to and what — the list shows exactly what a customer would see. Nothing is ordered or kept aside.",
    "how": "Delivery",
    "method": {
      "ship": "Send",
      "pickup": "Pick up at the shop"
    },
    "country": "Country",
    "prefecture": "Prefecture",
    "prefecture_any": "Any",
    "lookup": "Card or box from the shop (scan or type its code)",
    "lookup_button": "Add",
    "lookup_hint": "Its price and weight are filled in.",
    "not_found": "Nothing in the shop has this code.",
    "item": "Item {{row}}",
    "kind": "Kind",
    "qty": "How many",
    "pieces": "pcs",
    "price": "Item {{row}}: price",
    "weight": "Weight of one",
    "weight_hint": "Empty = the standard weight (Packing tab).",
    "export_price": "Price without tax (for export)",
    "export_price_hint": "Needed for the duty estimate.",
    "add_item": "Add an item",
    "remove_item": "Remove item {{row}}",
    "result": "What the customer sees",
    "fill_in": "Type a price to see the ways to ship.",
    "zone": "Zone",
    "pickup": "Pick up",
    "parcel_weight": "Parcel weight",
    "value": "Value",
    "notices": "Messages at checkout",
    "options": "Ways to ship, cheapest first",
    "free": "Free shipping",
    "insured_up_to": "Insured up to {{amount}}",
    "duty_estimate": "Duty estimate {{amount}}",
    "hidden": "Not offered for this parcel",
    "hidden_row": "{{name}} — {{reason}}",
    "hidden_reason": {
      "insurance_required": "not insured (order too valuable)",
      "declared_value_too_high": "value too high for it",
      "too_heavy": "too heavy",
      "subtotal_out_of_range": "order total outside its range",
      "too_thick": "too thick",
      "carrier_off": "company switched off for this zone"
    },
    "thickness": "Thickness of one",
    "thickness_hint": "Empty = the standard thickness (Packing tab).",
    "parcel_thickness": "Parcel thickness"
  },
  "notice": {
    "checkout_ddp_us_notice": "US: import duty is prepaid by the shop (included in the price shown).",
    "checkout_ddu_notice": "Import duty and fees may be charged on arrival.",
    "checkout_duties_estimate_unavailable": "No duty estimate: an item has no price without tax.",
    "checkout_duties_us_ddp": "US: import duty is prepaid by the shop.",
    "checkout_duties_ddu": "Import duty and fees may be charged on arrival.",
    "checkout_duties_uk_135": "UK: VAT is added for orders up to £135.",
    "shipping_insurance_required": "Orders of {{threshold}} or more are sent insured only.",
    "shipping_free_shipping_applied": "Free shipping applied.",
    "other": "A message about duties or shipping is shown to the customer."
  },
  "problem": {
    "zone_conflict": "Already in the zone {{zone}}: {{places}}. Remove them there first, or switch that zone off.",
    "zone_has_rates": "This zone still has ways to ship. Delete them first, or switch the zone off.",
    "unknown_prefecture": "Unknown prefecture: {{value}}",
    "rate": {
      "thresholds_not_ascending": "Row {{row}}: each \"up to\" must be bigger than the row above (steps may not overlap).",
      "price_decreases_with_weight": "Row {{row}}: a heavier step may not be cheaper than the one above.",
      "threshold_required": "Row {{row}}: type the \"up to\" weight or amount.",
      "required_for_type": "Add at least one row with a price.",
      "unknown_carrier": "This delivery company is not known. Choose another one.",
      "greater_than_max": "The smallest number is bigger than the biggest one.",
      "before_effective_from": "The end day is before the start day."
    },
    "quote": {
      "no_zone": "No zone includes this place, so customers there cannot order.",
      "no_rates": "The zone has no way to ship yet.",
      "all_rates_hidden": "No way to ship fits this parcel (too valuable, too heavy or outside the order total).",
      "no_pickup_location": "No shop is set up for picking up.",
      "too_heavy": "The parcel ({{weight}} g) is heavier than every way to ship (up to {{max}} g)."
    }
  }
}
